// extracted by mini-css-extract-plugin
export default {"privacyHtml":"TravellerPrivacy_privacyHtml__ylOb3"};